import {
  RESET_WEEK_RESERVATIONS,
  SET_WEEK_RESERVATION,
  DELETE_WEEK_RESERVATION
} from 'actions/account/forms/weekReservationsForm/actionTypes'

import resetWeekReservations from './resetWeekReservations'
import setWeekReservation from './setWeekReservation'
import deleteWeekReservation from './deleteWeekReservation'

const reducer = (state = {}, action) => {
  switch (action.type) {
    case SET_WEEK_RESERVATION:
      return setWeekReservation(state, action)
    case DELETE_WEEK_RESERVATION:
      return deleteWeekReservation(state, action)
    case RESET_WEEK_RESERVATIONS:
      return resetWeekReservations(state, action)
    default:
      return state
  }
}

export default reducer
